import React, { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom";
import * as applicationService from "services/application-service";
import * as certificateService from "services/certificate-service";
import AllSteps from "./stepsAll/all";
import { Formik, FormikValues, Form } from "formik";
import { FileUploadType } from "components/formsUI/FileUpload";
import i18next from "i18next";
import * as Yup from "yup";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import countries from "resources/countries_en_nl.json";
import { convertFormikToApplicationWithDetails } from "utilities/formik-values-converter";
import { Box, Button, Card, CardProps, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import * as Styles from "pages/requests/dataCompletion.styles";
import { idValidation } from "utilities/idValidation";
import { isNationalityBelgian } from "./formHelper";

export const isRequired = (form: any, fieldName: string): boolean => {
    const fieldDescription = form.describe().fields[fieldName] as any;
    if (fieldDescription.tests[0] && fieldDescription.tests.filter((obj: any) => obj.name === 'required').length > 0) return true
    return false;
}

export interface INITIAL_FORM_STATE_TYPE {
    userFirstName?: string,
    userLastName?: string,
    userBirthDay?: string,
    userNationality?: string | null,
    userBirthPlace?: string,
    userRRN?: string,
    userAddressStreet?: string,
    userAddressHouseNumber?: string,
    userAddressBox?: string,
    userAddressZip?: string,
    userAddressCity?: string,
    userAddressCountry?: string | null,
    userEmail?: string,
    userDepartment?: string,
    companyName?: string,
    companyResponsibleFirstName?: string,
    companyResponsibleLastName?: string,
    companyResponsibleEmail?: string,
    dateFrom?: string,
    dateTo?: string,
    locations?: string[],
    reason?: string,
    function?: string,
    fileUpload?: FileUploadType[],
};

const INITIAL_FORM_STATE: INITIAL_FORM_STATE_TYPE = {
    userFirstName: "",
    userLastName: "",
    userBirthDay: "",
    userNationality: null,
    userBirthPlace: "",
    userRRN: "",
    userAddressStreet: "",
    userAddressHouseNumber: "",
    userAddressBox: "",
    userAddressZip: "",
    userAddressCity: "",
    userAddressCountry: null,
    userEmail: "",
    companyName: "",
    companyResponsibleFirstName: "",
    companyResponsibleLastName: "",
    companyResponsibleEmail: "",
    dateFrom: "",
    dateTo: "",
    locations: [],
    reason: "",
    function: "",
    fileUpload: [],
};

const FORM_VALIDATION = (t: any, titlePath: string) => {
    const locale = i18next.language === undefined ? "nl" : i18next.language;
    console.log(titlePath)
    switch (titlePath) {
        case 'renew.completeTitle': {
            return Yup.object().shape({
                userFirstName: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .optional()
                    .nullable(),
                // .required(''),
                userLastName: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .optional().nullable(),
                userBirthDay: Yup.date()
                    .typeError("yup.validDate")
                    // .required("yup.required"),
                    .optional().nullable(),
                userNationality: Yup.string()
                    .nullable()
                    .test('value', 'yup.validNationality', (val) => {
                        const nationalties = countries.filter((_, index) => {
                            const option: any = countries[index]
                            if (option.nationality !== undefined) return option
                        }).map((_, index) => {
                            const option = countries[index];
                            if (locale === 'en') return option?.nationality?.en;
                            if (locale === 'fr') return option?.nationality?.fr;
                            return option?.nationality?.nl
                        })
                        if (val !== null && val !== undefined) return nationalties.includes(val);
                        return true;
                    })
                    // .required("yup.required"),
                    .optional(),
                userBirthPlace: Yup.string()
                    // .required("yup.required"),
                    .optional().nullable(),
                userRRN: Yup.object().when('userNationality', (userNationality) => {
                    if (isNationalityBelgian(userNationality)) {
                        return Yup.string()
                            // .matches(/[0-9]{11}/gi, t("yup.step1.id"))
                            .test('value', 'yup.step1.rrnUnValid', (val) => {
                                return idValidation(val);
                            })
                            .typeError("yup.step1.numberType")
                            // .required("yup.required")
                            .nullable()
                            .optional()
                    }
                    // return Yup.string().required("yup.required");
                    return Yup.string().nullable().optional();
                }),
                userAddressStreet: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    // .required("yup.required"),
                    .nullable()
                    .optional(),
                userAddressHouseNumber: Yup.string()
                    // .required("yup.required"),
                    .matches(/.*\d.*/, 'yup.invalid')
                    .nullable()
                    .optional(),
                userAddressBox: Yup.string()
                    .nullable()
                    .optional(),
                userAddressZip: Yup.string()
                    .when('userNationality', (userNationality) => {
                        if (isNationalityBelgian(userNationality)) {
                            return Yup.string().matches(/^\d{4}$/, 'yup.invalid').length(4);
                        }
                        return Yup.string();
                    })
                    // .required("yup.required"),
                    .nullable()
                    .optional(),
                userAddressCity: Yup.string()
                    // .required("yup.required"),
                    .nullable()
                    .optional(),
                userAddressCountry: Yup.string()
                    .nullable()
                    .test('value', 'yup.validCountry', (val) => {
                        const nationalties = countries.filter((_, index) => {
                            const option: any = countries[index]
                            if (option.name !== undefined) return option
                        }).map((_, index) => {
                            const option: any = countries[index];
                            if (locale === 'en') return option?.name?.en;
                            if (locale === 'fr') return option?.name?.fr;
                            return option?.name?.nl
                        })
                        if (val !== null && val !== undefined) return nationalties.includes(val);
                        return true;
                    })
                    //   .required("yup.required"),
                    .optional(),
                userEmail: Yup.string()
                    .email("yup.email")
                    .required("yup.required"),
                companyName: Yup.string().nullable().optional(),
                userDepartment: Yup.string().nullable().optional(),
                companyResponsibleFirstName: Yup.string()
                    .nullable()
                    .optional(),
                companyResponsibleLastName: Yup.string()
                    .nullable()
                    .optional(),
                companyResponsibleEmail: Yup.string()
                    .email("yup.email")
                    .nullable()
                    .optional(),
                dateFrom: Yup.date()
                    .typeError("yup.step3.dateError")
                    .required("yup.required")
                    .test(
                        "is-today",
                        "yup.step3.dateFrom",
                        (date) => dayjs().diff(date, "days") <= 0
                    )
                    .test(
                        "is-max-3m-in-future",
                        "yup.step3.dateFrom3Months",
                        (date) => dayjs().add(3, "months").diff(date, "days") >= 0
                    ),
                dateTo: Yup.date()
                    .typeError("yup.step3.dateError")
                    .when("dateFrom", (dateFrom: Date, schema: Yup.DateSchema) => {
                        const day = dayjs(dateFrom).add(1, "years").subtract(1, "day");
                        if (dateFrom == null)
                            return schema.max(dayjs(), "yup.step3.dateFromIsEmpty");
                        return schema.max(
                            day,
                            `${"yup.step3.maxDate"} (${day
                                .format("DD/MM/YYYY")})`
                        );
                    })
                    .min(Yup.ref("dateFrom"), "yup.step3.minDate")
                    .required("yup.required"),
                locations: Yup.array().min(1, t("yup.step3.locations")).required("yup.required"),
                reason: Yup.string().nullable().optional(),
                function: Yup.string().nullable().optional(),
            })
        }
        case 'requestAll.startTitle': {
            return Yup.object().shape({
                userFirstName: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .optional(),
                // .required(''),
                userLastName: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .optional(),
                userBirthDay: Yup.date()
                    .typeError("yup.validDate")
                    // .required("yup.required"),
                    .optional(),
                userNationality: Yup.string()
                    .nullable()
                    .test('value', 'yup.validNationality', (val) => {
                        const nationalties = countries.filter((_, index) => {
                            const option: any = countries[index]
                            if (option.nationality !== undefined) return option
                        }).map((_, index) => {
                            const option = countries[index];
                            if (locale === 'en') return option?.nationality?.en;
                            if (locale === 'fr') return option?.nationality?.fr;
                            return option?.nationality?.nl
                        })
                        if (val !== null && val !== undefined) return nationalties.includes(val);
                        return true;
                    })
                    // .required("yup.required"),
                    .optional(),
                userBirthPlace: Yup.string()
                    // .required("yup.required"),
                    .optional(),
                userRRN: Yup.object().when('userNationality', (userNationality) => {
                    if (isNationalityBelgian(userNationality)) {
                        return Yup.string()
                            // .matches(/[0-9]{11}/gi, "yup.step1.id")
                            .test('value', 'yup.step1.rrnUnValid', (val) => {
                                if (val !== '' && val !== null && val !== undefined)
                                    return idValidation(val);
                                return true;
                            })
                            .typeError("yup.step1.numberType")
                            // .required("yup.required")
                            .optional()
                    }
                    // return Yup.string().required("yup.required");
                    return Yup.string().optional();
                }),
                userAddressStreet: Yup.string()
                    // .required("yup.required"),
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .optional(),
                userAddressHouseNumber: Yup.string()
                    .matches(/.*\d.*/, 'yup.invalid')
                    // .required("yup.required"),
                    .optional(),
                userAddressBox: Yup.string()
                    .optional(),
                userAddressZip: Yup.string()
                    .when('userNationality', (userNationality) => {
                        if (isNationalityBelgian(userNationality)) {
                            return Yup.string().matches(/^\d{4}$/, 'yup.invalid').length(4);
                        }
                        return Yup.string();
                    })
                    // .required("yup.required"),
                    .optional(),
                userAddressCity: Yup.string()
                    // .required("yup.required"),
                    .optional(),
                userAddressCountry: Yup.string()
                    .nullable()
                    .test('value', 'yup.validCountry', (val) => {
                        const nationalties = countries.filter((_, index) => {
                            const option: any = countries[index]
                            if (option.name !== undefined) return option
                        }).map((_, index) => {
                            const option: any = countries[index];
                            if (locale === 'en') return option?.name?.en;
                            if (locale === 'fr') return option?.name?.fr;
                            return option?.name?.nl
                        })
                        if (val !== null && val !== undefined) return nationalties.includes(val);
                        return true;
                    })
                    //   .required("yup.required"),
                    .optional(),
                userEmail: Yup.string()
                    .email("yup.email")
                    .required("yup.required"),
                companyName: Yup.string().optional(),
                userDepartment: Yup.string().optional(),
                companyResponsibleFirstName: Yup.string()
                    .optional(),
                companyResponsibleLastName: Yup.string()
                    .optional(),
                companyResponsibleEmail: Yup.string()
                    .email("yup.email")
                    .optional(),
                dateFrom: Yup.date()
                    .typeError("yup.step3.dateError")
                    .required("yup.required")
                    .test(
                        "is-today",
                        "yup.step3.dateFrom",
                        (date) => dayjs().diff(date, "days") <= 0
                    )
                    .test(
                        "is-max-3m-in-future",
                        "yup.step3.dateFrom3Months",
                        (date) => dayjs().add(3, "months").diff(date, "days") >= 0
                    ),
                dateTo: Yup.date()
                    .typeError("yup.step3.dateError")
                    .when("dateFrom", (dateFrom: Date, schema: Yup.DateSchema) => {
                        const day = dayjs(dateFrom).add(1, "years");
                        if (dateFrom == null)
                            return schema.max(dayjs(), "yup.step3.dateFromIsEmpty");
                        return schema.max(
                            day,
                            `${"yup.step3.maxDate"} (${day
                                .format("DD/MM/YYYY")})`
                        );
                    })
                    .min(Yup.ref("dateFrom"), "yup.step3.minDate")
                    .required("yup.required"),
                locations: Yup.array().min(1, "yup.step3.locations").required("yup.required"),
                reason: Yup.string().optional(),
                function: Yup.string().optional(),
            })
        }
        case 'requestAll.title':
        case 'requestAll.completeTitle': {
            return Yup.object().shape({
                userFirstName: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .required("yup.required"),
                userLastName: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .required("yup.required"),
                userBirthDay: Yup.date()
                    .typeError("yup.validDate")
                    .test("is-today", "yup.step1.birthDay", (date) => {
                        // console.log(dayjs().diff(date, "years"));
                        return dayjs().diff(date, "years") >= 14;
                    })
                    .required("yup.required"),
                // .optional(),
                userNationality: Yup.string()
                    .nullable()
                    .test('value', 'yup.validNationality', (val) => {
                        const nationalties = countries.filter((_, index) => {
                            const option: any = countries[index]
                            if (option.nationality !== undefined) return option
                        }).map((_, index) => {
                            const option = countries[index];
                            if (locale === 'en') return option?.nationality?.en;
                            if (locale === 'fr') return option?.nationality?.fr;
                            return option?.nationality?.nl
                        })
                        if (val !== null && val !== undefined) return nationalties.includes(val);
                        return true;
                    })
                    .required("yup.required"),
                // .optional(),
                userBirthPlace: Yup.string()
                    .required("yup.required"),
                // .optional(),
                userRRN: Yup.object().when('userNationality', (userNationality) => {
                    if (isNationalityBelgian(userNationality)) {
                        return Yup.string()
                            // .matches(/[0-9]{11}/gi, t("yup.step1.id"))
                            .test('value', 'yup.step1.rrnUnValid', (val) => {
                                return idValidation(val);
                            })
                            .typeError("yup.step1.numberType")
                            .required("yup.required")
                        // .optional()
                    }
                    return Yup.string().required("yup.required");
                    // return Yup.string().optional();
                }),
                userAddressStreet: Yup.string()
                    .matches(/^(?!\d+$).+/, 'yup.invalid')
                    .required("yup.required"),
                // .optional(),
                userAddressHouseNumber: Yup.string()
                    .matches(/.*\d.*/, 'yup.invalid')
                    .required("yup.required"),
                // .optional(),
                userAddressBox: Yup.string()
                    .optional(),
                userAddressZip: Yup.string()
                    .when('userNationality', (userNationality) => {
                        if (isNationalityBelgian(userNationality)) {
                            return Yup.string().matches(/^\d{4}$/, 'yup.invalid').length(4);
                        }
                        return Yup.string();
                    })
                    .required("yup.required"),
                // .optional(),
                userAddressCity: Yup.string()
                    .required("yup.required"),
                // .optional(),
                userAddressCountry: Yup.string()
                    .nullable()
                    .test('value', 'yup.validCountry', (val) => {
                        const nationalties = countries.filter((_, index) => {
                            const option: any = countries[index]
                            if (option.name !== undefined) return option
                        }).map((_, index) => {
                            const option: any = countries[index];
                            if (locale === 'en') return option?.name?.en;
                            if (locale === 'fr') return option?.name?.fr;
                            return option?.name?.nl
                        })
                        if (val !== null && val !== undefined) return nationalties.includes(val);
                        return false;
                    })
                    .required("yup.required"),
                // .optional(),
                userEmail: Yup.string()
                    .email("yup.email")
                    .required("yup.required"),
                companyName: Yup.string().required("yup.required"),
                companyResponsibleFirstName: Yup.string()
                    .required("yup.required"),
                companyResponsibleLastName: Yup.string()
                    .required("yup.required"),
                companyResponsibleEmail: Yup.string()
                    .email("yup.email")
                    .required("yup.required"),
                dateFrom: Yup.date()
                    .typeError("yup.step3.dateError")
                    .required("yup.required")
                    .test(
                        "is-today",
                        "yup.step3.dateFrom",
                        (date) => dayjs().diff(date, "days") <= 0
                    )
                    .test(
                        "is-max-3m-in-future",
                        "yup.step3.dateFrom3Months",
                        (date) => dayjs().add(3, "months").diff(date, "days") >= 0
                    ),
                dateTo: Yup.date()
                    .typeError("yup.step3.dateError")
                    .when("dateFrom", (dateFrom: Date, schema: Yup.DateSchema) => {
                        const day = dayjs(dateFrom).add(1, "years").add(1, "day");
                        if (dateFrom == null)
                            return schema.max(dayjs(), "yup.step3.dateFromIsEmpty");
                        return schema.max(
                            day,
                            `${"yup.step3.maxDate"} (${day
                                .subtract(1, "day")
                                .format("DD/MM/YYYY")})`
                        );
                    })
                    .min(Yup.ref("dateFrom"), "yup.step3.minDate")
                    .required("yup.required"),
                locations: Yup.array().min(1, "yup.step3.locations").required(),
                reason: Yup.string().required("yup.required"),
                function: Yup.string().required("yup.required"),
            });
        }
    }
}

interface IProps {
    titlePath: string;
}

function DataCompletion(props: IProps) {
    const { applicationId, step, completionHash, certificateId } = useParams();
    const { titlePath } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.between("xs", "md"));
    const [formState, setFormState] = React.useState<{ isLoaded: boolean, value: INITIAL_FORM_STATE_TYPE }>({
        isLoaded: false, value: INITIAL_FORM_STATE
    });
    const [form, setForm] = React.useState<any>(null);
    const [application, setApplication] = React.useState<any>();
    const [error, setError] = React.useState<string>('');
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        console.log(titlePath)
        if (titlePath === 'renew.completeTitle') {
            console.log('renew')
            if (certificateId !== null && certificateId !== undefined) {
                certificateService.getCertificateWithDetails(certificateId).then((res: CertificateWithDetails) => {
                    console.log(res)
                    setApplication(res.application);
                    const app = res.application;
                    // TODO: convert to formatter
                    let dateFrom = dayjs(app.dateFrom);
                    let dateTo = dayjs(app.dateTo);
                    if (dateFrom.isBefore(dayjs()) && dateTo.isAfter(dayjs())) {
                        dateFrom = dateTo.add(1, 'day');
                        dateTo = dateFrom.add(1, 'year').subtract(1, 'day');
                    } else if (dateFrom.isBefore(dayjs()) && dateTo.isBefore(dayjs())) {
                        dateFrom = dayjs();
                        dateTo = dateFrom.add(1, 'year').subtract(1, 'day');
                    } else {
                        dateTo = dateTo.add(1, 'year');
                    }
                    setFormState({
                        isLoaded: true,
                        value: {
                            userFirstName: app.applicant?.firstName,
                            userLastName: app.applicant?.lastName,
                            userBirthDay: app.applicant?.birthDay?.toString(),
                            userNationality: app.applicant?.nationality,
                            userBirthPlace: app.applicant?.birthPlace,
                            userAddressBox: app.applicant?.address?.box ? app.applicant?.address?.box : '',
                            userAddressCity: app.applicant?.address?.city ? app.applicant?.address?.city : '',
                            userAddressCountry: app.applicant?.address?.country ? app.applicant?.address?.country : '',
                            userAddressHouseNumber: app.applicant?.address?.houseNumber ? app.applicant?.address?.houseNumber : '',
                            userAddressStreet: app.applicant?.address?.street ? app.applicant?.address?.street : '',
                            userAddressZip: app.applicant?.address?.zip ? app.applicant?.address?.zip : '',
                            userDepartment: app.department?.name ? app.department?.name : '',
                            userEmail: app.applicant?.email,
                            userRRN: app.applicant?.rrn,
                            companyName: app.responsible?.company?.name,
                            companyResponsibleFirstName: app.responsible?.firstName,
                            companyResponsibleLastName: app.responsible?.lastName,
                            companyResponsibleEmail: app.responsible?.email,
                            dateFrom: dateFrom.toString(),
                            dateTo: dateTo.toString(),
                            locations: app?.locations?.map(loc => loc.name),
                            reason: app?.reason,
                            function: app?.function,
                            fileUpload: undefined,
                        }
                    })
                })
            }
        }
        if (applicationId !== null && applicationId !== undefined && completionHash !== null && completionHash !== undefined) {
            applicationService.getApplicationByIdAndHash(applicationId, completionHash).then(res => {
                if (res !== undefined) {
                    setApplication(res);
                    // TODO: convert to formatter
                    setFormState({
                        isLoaded: true,
                        value: {
                            userFirstName: res.applicant?.firstName,
                            userLastName: res.applicant?.lastName,
                            userBirthDay: res.applicant?.birthDay.toString(),
                            userNationality: res.applicant?.nationality,
                            userBirthPlace: res.applicant?.birthPlace,
                            userAddressBox: res.applicant?.address?.box,
                            userAddressCity: res.applicant?.address?.city,
                            userAddressCountry: res.applicant?.address?.country,
                            userAddressHouseNumber: res.applicant?.address?.houseNumber,
                            userAddressStreet: res.applicant?.address?.street,
                            userAddressZip: res.applicant?.address?.zip,
                            userEmail: res.applicant?.email,
                            userRRN: res.applicant?.rrn,
                            companyName: res.responsible?.company?.name,
                            companyResponsibleFirstName: res.responsible?.firstName,
                            companyResponsibleLastName: res.responsible?.lastName,
                            companyResponsibleEmail: res.responsible?.email,
                            dateFrom: res.dateFrom?.toString(),
                            dateTo: res.dateTo?.toString(),
                            locations: res?.locations?.map(loc => loc.name),
                            reason: res.reason,
                            function: res.function,
                            fileUpload: res.attachments?.filter(a => a.isEditable === false).map(attachement => {
                                const type = attachement.type.split('/');
                                return {
                                    id: attachement.applicationId as string,
                                    file: new File(new Array<BlobPart>(attachement.size), attachement.name, { type: attachement.type }),
                                    progress: 100,
                                    extension: type[type.length - 1],
                                    dbId: attachement.id,
                                };
                            })
                        }
                    })
                }
            });
            return;
        }
        if (applicationId !== null && applicationId !== undefined) {
            setFormState({ isLoaded: true, value: INITIAL_FORM_STATE })
        }
        setForm(FORM_VALIDATION(t, titlePath))
    }, [applicationId, step, completionHash, setApplication])

    const handleSubmit = (values: FormikValues) => {
        setError('');
        setIsLoading(true);
        if (application == null || application == undefined) {
            const data = convertFormikToApplicationWithDetails(applicationId, values);
            applicationService.startCompletionApplication(data).then(res => {
                setSubmitted(true);
                setIsLoading(false);
            }).catch(() => {
                setError(t('errors.500'));
                setIsLoading(false);
            })
            return
        }
        if (titlePath === 'renew.completeTitle' && certificateId !== null && certificateId !== undefined) {
            const data = convertFormikToApplicationWithDetails(application.id, values);
            console.log(data)
            certificateService.renewCertificate(certificateId, data).then(res => {
                setSubmitted(true);
                setIsLoading(false);
            }).catch(() => {
                setError(t('errors.500'));
                setIsLoading(false);
            })
            return;
        }
    }

    const CardProps: CardProps = {
        sx: {
            px: "4rem",
            py: "20px",
            borderRadius: "30px",
            width: { xs: "200px", md: "500px", lg: "600px" },
            alignItems: 'center',
            alignContent: 'center',
            textAlign: 'center',
        }
    }

    const handleCompletion = (): boolean => {
        if (titlePath == 'requestAll.completeTitle') return true;
        return false
    }

    function handleManage() {
        navigate("/beheer");
    }

    return (!submitted ?
        <Box sx={Styles.wrapper(theme)}>
            {!formState.isLoaded ?
                <Card sx={Styles.cardCSS(theme)}>
                    <CircularProgress />
                </Card> :
                <Formik
                    initialValues={formState.value}
                    onSubmit={handleSubmit}
                    validationSchema={form}
                >
                    <Form
                        style={{ zIndex: 1 }}
                    >
                        <AllSteps
                            form={form}
                            titlePath={titlePath}
                            application={application}
                            submitDisabled={isLoading}
                            error={error}
                            isRenew={titlePath === 'renew.completeTitle'}
                        />
                    </Form>
                </Formik>
            }
        </Box> :
        <Box maxWidth="lg" sx={Styles.wrapper(theme)}>
            {isMobile ? (
                <Box sx={Styles.containerCSS(theme)}>
                    <h1>{t("startRequest.titleSubmitted")}</h1>
                    <Box sx={Styles.infotext(theme)}>
                        {t("startRequest.textSubmitted")}
                    </Box>
                </Box>
            ) : (
                <Card sx={Styles.cardCSS(theme)}>
                    <Box sx={Styles.containerCSS(theme)}>
                        <h1>{t("startRequest.titleSubmitted")}</h1>
                        <Box sx={Styles.infotext(theme)}>
                            {t("startRequest.textSubmitted")}
                        </Box>
                        <Button sx={{ mt: 3 }} variant="contained" onClick={handleManage}>
                            {t('startRequest.buttonManage')}
                        </Button>
                    </Box>
                </Card>
            )}
        </Box>
    )

}

export default DataCompletion;
